"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgGitlab = function SvgGitlab(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M34.003 25.624l-1.224-3.625-1.892-5.824L29 21.979a1 1 0 01-.951.691h-8.1a1 1 0 01-.95-.69l-1.892-5.807-1.886 5.804-1.186 3.675L24 32.894l10.003-7.27zm-9.415 9.315a1 1 0 01-1.176 0l-10.654-7.743a1.838 1.838 0 01-.66-2.053l1.22-3.782 2.46-7.562c.08-.207.207-.392.368-.537a1.436 1.436 0 011.949.019 1.4 1.4 0 01.366.59l2.215 6.799h6.648l2.233-6.87c.08-.208.208-.393.369-.538a1.436 1.436 0 011.949.019 1.4 1.4 0 01.366.59l2.436 7.499 1.283 3.8a1.84 1.84 0 01-.74 2.042l-10.632 7.727z",
    id: "gitlab_svg__a"
  }));
};

var _default = SvgGitlab;
exports["default"] = _default;